import { $t } from '@/locales'
import { getShowUnit, getShowPrice } from '@/util.js'

const fomrateffectiveUnit = {
  MONTH: $t('月'),
  YEAR: $t('年'),
  DAY: $t('日'),
}

export default {
  data() {
    return {
      fomrateffectiveUnit,
      getShowUnit,
      getShowPrice,
    }
  },
}
